import type { UseCase } from '@cleanpro/common-ui';
import { CustomerResponse } from '../types';
import { CustomerRepository } from '../repositories/CustomerRepository';

export interface GetAllCustomersRequest {
  // Could include pagination parameters in the future
  page?: number;
  limit?: number;
}

export interface GetAllCustomersResponse {
  customers: CustomerResponse[];
  total: number;
}

export class GetAllCustomersUseCase implements UseCase<GetAllCustomersRequest, GetAllCustomersResponse> {
  constructor(private customerRepository: CustomerRepository) {}

  async execute(_request: GetAllCustomersRequest): Promise<GetAllCustomersResponse> {
    const customers = await this.customerRepository.findAll();
    const total = await this.customerRepository.count();

    return {
      customers: customers.map(customer => ({
        id: customer.id,
        name: customer.name,
        email: customer.email,
        phone: customer.phone,
        address: customer.address,
        preferences: customer.preferences,
        rating: customer.rating,
        totalSpent: customer.totalSpent,
        lastService: customer.lastService,
        createdAt: customer.createdAt.toISOString(),
        updatedAt: customer.updatedAt.toISOString()
      })),
      total
    };
  }
}